import React from "react";
import classNames from "../../classNames";

const noop = () => {};
const defaultProps = {
  type: "text",
  strict: false,
  onChange: noop,
};

function Phil({ className, onChange, uppercase, ...props }) {
  function onInput(e) {
    let value = e.target.value;

    // Remove all non-numeric characters
    value = value.replace(/\D/g, "");

    // Insert dash after the second digit
    value = value.replace(/(\d{2})(?=\d)/, "$1-");

    // Insert dash after the 11th digit
    value = value.replace(/(\d{9})(?=\d)/, "$1-");

    // Trim extra dash at the end
    value = value.replace(/-$/, "");

    // Add exclamation mark at the end
    value = value.replace(/(\d{2})-(\d{9})-(\d{2})/, "$1-$2-$3!");

    // Enforce limit of characters
    const limit = 15; // Updated limit of 15 characters
    if (value.length > limit) {
      value = value.substring(0, limit);
    }

    if (uppercase) {
      value = value.toUpperCase();
    }

    e.target.value = value;
    onChange(value);
  }

  return (
    <div>
      <input
        className={classNames("form-control", className)}
        onInput={onInput}
        {...props}
      />
      <br />
    </div>
  );
}
Phil.defaultProps = defaultProps;
export default Phil;
